/**
 * FilterSearch Constants
 *
 * This file contains default configuration values and constants
 * used by the FilterSearch component.
 */

import type { FilterOption } from "./types";

/**
 * Default set of filter options provided when no custom filters are specified.
 * Includes examples of:
 * - Simple text filters (name, email, phone, etc.)
 * - Numeric filters with sub-options (price)
 * - Date filters (expires)
 * - Filters with immediate-apply sub-options (plans)
 */
export const DEFAULT_FILTERS: FilterOption[] = [
  // Simple text filters - user types value and presses Enter
  { key: "name", label: "Name" },
  { key: "email", label: "Email" },
  { key: "phone", label: "Phone" },
  { key: "city", label: "City" },
  { key: "status", label: "Status" },

  // Numeric filter with comparison sub-options
  // User selects condition (more than, less than, equal) then enters number
  {
    key: "price",
    label: "Price",
    type: "number",
    inputType: "number",
    subOptions: [
      { key: "more_than", label: "More than", displayLabel: "more than" },
      { key: "less_than", label: "Less than", displayLabel: "less than" },
      { key: "equal", label: "Equal", displayLabel: "equal to" },
    ],
  },

  // Date filter - opens date picker instead of text input
  {
    key: "expires",
    label: "Expires",
    type: "date",
  },

  // Filter with immediate-apply sub-options
  // Selecting a sub-option applies the filter without additional input
  {
    key: "plans",
    label: "Plans",
    subOptions: [
      { key: "free", label: "Free", displayLabel: "free", applyImmediately: true },
      { key: "paid", label: "Paid", displayLabel: "paid", applyImmediately: true },
      {
        key: "enterprise",
        label: "Enterprise",
        displayLabel: "enterprise",
        applyImmediately: true,
      },
    ],
  },
];

/**
 * Default placeholder text for the search input
 */
export const DEFAULT_PLACEHOLDER = "Click to add filters...";

/**
 * Animation duration for dropdown transitions (in milliseconds)
 */
export const DROPDOWN_TRANSITION_DURATION = 200;

/**
 * Z-index for dropdown popper elements
 */
export const DROPDOWN_Z_INDEX = 1300;
